
import { Skeleton } from "@/components/ui/skeleton"

export const LoadingSpinner = ({ fullPage = false }: { fullPage?: boolean }) => {
  if (fullPage) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center space-y-4">
          <div className="w-12 h-12 border-4 border-edgefi-purple border-t-transparent rounded-full animate-spin mx-auto" />
          <div className="h-4 w-32 bg-gray-200 rounded mx-auto"></div>
        </div>
      </div>
    );
  }

  return (
    <div className="flex items-center justify-center p-4">
      <div className="w-8 h-8 border-3 border-edgefi-purple border-t-transparent rounded-full animate-spin" />
    </div>
  );
};
